import React, {useContext, useState, useEffect} from 'react';
import MobileEntityListItem from './MobileEntityListItem';
import {Button} from 'reactstrap';
import {useHistory} from 'react-router-dom';
import MobileLoadingScreen from 'components/MobileLoadingScreen';
import {EntityContext} from 'contexts/EntityContext';
import {filterByValue} from 'Helpers/filterByValue';
import SearchInput from 'components/SearchInput';
import {VariableSizeList as List} from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

const MobileEntityList = (props) => {
    let history = useHistory();
    const {pendingEntities} = useContext(EntityContext);
    const {fullEntitiesList, entitiesLoading} = props;
    const [searchValue, setSearchValue] = useState('');
    const [visibleList, setVisibleList] = useState([]);

    useEffect(() => {
        let filteredArr = searchValue.length ? filterByValue(fullEntitiesList, 'title', searchValue) : [...fullEntitiesList];
        setVisibleList(filteredArr);
    }, [searchValue, fullEntitiesList]);


    const Row = ({index, style}) => (
        <div key={index} style={{...style, margin: '0 auto'}}>
            <MobileEntityListItem entity={visibleList[index]} pendingEntities={pendingEntities}/>
        </div>
    );

    const resetSearch = () => setSearchValue('');

    if(entitiesLoading) return <MobileLoadingScreen/>
    return (
        <div>
            <h2 className="pl-3 pr-3 pt-3 pb-0">Entities</h2>
            <div className="p-3">
                <SearchInput
                    value={searchValue}
                    onChange={setSearchValue}
                    placeholder="Search entities"
                    onClear={resetSearch}
                />
            </div>
            {fullEntitiesList && fullEntitiesList.length ?
                <AutoSizer>
                    {({height, width}) => (
                        <List
                            width={width}
                            height={height}
                            itemCount={visibleList.length}
                            itemSize={() => 62}
                            estimatedItemSize={62}
                            // ref={scrollRef}
                        >
                            {Row}
                        </List>
                    )}
                </AutoSizer>
                :
                <>
                    <div>No entities have been created yet</div>
                    <Button className="calltoaction-button mt-3" onClick={() => history.push('/add-entity')}>
                        Add entity
                    </Button>
                </>
            }
        </div>
    );
};

export default MobileEntityList;
